// JavaScript source code
/* eslint-disable */
import React from 'react';
import { BaseFilter, ShowTitleByCode } from './Scaffolding';
import {
    TextField,
    Show,
    Create,
    BooleanField,
    SimpleForm,
    Edit,
    DateField,
    SimpleShowLayout,
    Datagrid,
} from 'react-admin';
import { SwList } from '../lib/SwList';
import { useAzureADGroups } from '../msal/useAzureADGroups';
import { ReadOnlyContext } from '../lib/context/ReadOnlyContext';
import { BooleanInput, TextInput } from '../lib/wrappers/Inputs';
import { EditToolbar } from '../layout/EditToolbar';

export const CostCentreLabels = {
    pageTitle: 'Cost Centres',
    costcentre: 'Cost centre',
};

export const CostCentreList = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SwList
                {...props}
                title={CostCentreLabels.pageTitle}
                filters={<BaseFilter />}
            >
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={!canEditStaticData ? false : undefined}
                >
                    <TextField source="id" />
                    <TextField source="code" />
                    <TextField
                        label={CostCentreLabels.costcentre}
                        source="costcentre"
                    />
                    <BooleanField source="current" />
                </Datagrid>
            </SwList>
        </ReadOnlyContext.Provider>
    );
};

export const CostCentreEdit = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <Edit title={<ShowTitleByCode />} {...props} redirect="edit">
                <SimpleForm toolbar={<EditToolbar />}>
                    <TextInput source="id" disabled />
                    <TextInput source="code" />
                    <TextInput
                        label={CostCentreLabels.costcentre}
                        source="costcentre"
                    />
                    <BooleanInput source="current" />
                    <TextInput source="created_at" disabled />
                    <TextInput source="updated_at" disabled />
                </SimpleForm>
            </Edit>
        </ReadOnlyContext.Provider>
    );
};

export const CostCentreCreate = (props) => {
    const { canEditStaticData } = useAzureADGroups();

    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <Create {...props} redirect="edit">
                <SimpleForm>
                    <TextInput source="code" />
                    <TextInput
                        label={CostCentreLabels.costcentre}
                        source="costcentre"
                    />
                    <BooleanInput source="current" />
                </SimpleForm>
            </Create>
        </ReadOnlyContext.Provider>
    );
};

export const CostCentreShow = (props) => (
    <Show title={<ShowTitleByCode />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="code" />
            <TextField
                label={CostCentreLabels.costcentre}
                source="costcentre"
            />
            <BooleanField source="current" />
            <TextField source="created_at" />
            <DateField source="updated_at" />
        </SimpleShowLayout>
    </Show>
);
